import { render, staticRenderFns } from "./VerticalSwitch.vue?vue&type=template&id=df1e8338"
import script from "./VerticalSwitch.vue?vue&type=script&lang=js"
export * from "./VerticalSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports